import React, { useState, useEffect } from 'react'; 
// import { postRangeFeeMaster } from '../api/paymentAPI'; 
import * as helper from '../global/helper'; 
import swal from 'sweetalert2'; 
import { getRangeFeeCalendarAll, getRangeFeeMasterByCalenderID, postRangeFeeMaster } from '../api/matAPI'; 
import Select from 'react-select';

const RangeFeeMaster = (props) => {

    const rows = [
        { no: 1,  CategoryID: 1, SubCategoryID: 1, Type: "Mat", UserType: 'OGR Member', WeekType: 'Weekday' },
        { no: 2,  CategoryID: 1, SubCategoryID: 1, Type: "Mat", UserType: 'OGR Member', WeekType: 'Weekends' },
        { no: 3,  CategoryID: 1, SubCategoryID: 1, Type: "Grass", UserType: 'OGR Member', WeekType: 'Weekday' },
        { no: 4,  CategoryID: 1, SubCategoryID: 1, Type: "Grass", UserType: 'OGR Member', WeekType: 'Weekends' },
        { no: 5,  CategoryID: 2, SubCategoryID: 5, Type: "Mat", UserType: 'Members Guest', WeekType: 'Weekday' },
        { no: 6,  CategoryID: 2, SubCategoryID: 5, Type: "Mat", UserType: 'Members Guest', WeekType: 'Weekends' },
        { no: 7,  CategoryID: 2, SubCategoryID: 5, Type: "Grass", UserType: 'Members Guest', WeekType: 'Weekday' },
        { no: 8,  CategoryID: 2, SubCategoryID: 5, Type: "Grass", UserType: 'Members Guest', WeekType: 'Weekends' },
        { no: 9,  CategoryID: 2, SubCategoryID: 4, Type: "Mat", UserType: 'Room Guest', WeekType: 'Weekday' },
        { no: 10, CategoryID: 2, SubCategoryID: 4, Type: "Mat", UserType: 'Room Guest', WeekType: 'Weekends' },
        { no: 11, CategoryID: 2, SubCategoryID: 4, Type: "Grass", UserType: 'Room Guest', WeekType: 'Weekday' },
        { no: 12, CategoryID: 2, SubCategoryID: 4, Type: "Grass", UserType: 'Room Guest', WeekType: 'Weekends' },
        { no: 13, CategoryID: 2, SubCategoryID: 3, Type: "Mat", UserType: 'Walking Guest', WeekType: 'Weekday' },
        { no: 14, CategoryID: 2, SubCategoryID: 3, Type: "Mat", UserType: 'Walking Guest', WeekType: 'Weekends' },
        { no: 15, CategoryID: 2, SubCategoryID: 3, Type: "Grass", UserType: 'Walking Guest', WeekType: 'Weekday' },
        { no: 16, CategoryID: 2, SubCategoryID: 3, Type: "Grass", UserType: 'Walking Guest', WeekType: 'Weekends' },
        { no: 17, CategoryID: 1, SubCategoryID: 2, Type: "Mat", UserType: 'Residence Owner', WeekType: 'Weekday' },
        { no: 18, CategoryID: 1, SubCategoryID: 2, Type: "Mat", UserType: 'Residence Owner', WeekType: 'Weekends' },
        { no: 19, CategoryID: 1, SubCategoryID: 2, Type: "Grass", UserType: 'Residence Owner', WeekType: 'Weekday' },
        { no: 20, CategoryID: 1, SubCategoryID: 2, Type: "Grass", UserType: 'Residence Owner', WeekType: 'Weekends' },
        { no: 21, CategoryID: 2, SubCategoryID: 8, Type: "Mat", UserType: 'Coached Guest', WeekType: 'Weekday' },
        { no: 22, CategoryID: 2, SubCategoryID: 8, Type: "Mat", UserType: 'Coached Guest', WeekType: 'Weekends' },
        { no: 23, CategoryID: 2, SubCategoryID: 8, Type: "Grass", UserType: 'Coached Guest', WeekType: 'Weekday' },
        { no: 24, CategoryID: 2, SubCategoryID: 8, Type: "Grass", UserType: 'Coached Guest', WeekType: 'Weekends' }
    ];

    const [allMaster, setAllMaster] = useState([]);
    const [calenderID, setCalenderID] = useState(null);
    const [rangeMasterList, setRangeMasterList] = useState([]);

    useEffect(() => {
        props.title("Range Fee Master", "range-fee-master");
        fetchRangeFeeCalendar();
    }, []);

    useEffect(() => {
        if (calenderID != null) {
            fetchRangeFeeMasterByCalenderID(calenderID);
        }
    }, [calenderID]);

    const fetchRangeFeeCalendar = async () => {
        try {
            const calendar = await getRangeFeeCalendarAll();
            setAllMaster(calendar); 
        } catch (error) {
            swal.fire({ icon: 'error', titleText: error.message });
        }
    }

    const   fetchRangeFeeMasterByCalenderID = async (calenderID) => {
        try {
            const master = await getRangeFeeMasterByCalenderID(calenderID);
            setRangeMasterList(master); 
        } catch (error) {
            swal.fire({ icon: 'error', titleText: error.message });
        }
    }

    const initialRateMasterDetails = rows.map(row => ({
        ID: row.ID,
        CalenderID: calenderID,
        CategoryID: row.CategoryID,
        SubCategoryID: row.SubCategoryID,
        UserType: row.UserType,
        WeekType: row.WeekType,
        Hole: row.Hole,
        IsWeekend: row.WeekType === "Weekday" ? "N" : "Y",
        Type: row.Type,
        GreenFee: 0,
        Bucket: 0,
        Club: 0,
        Tax: 0,
        Total: 0,
        Remark: '',
    }));

    const [rateMasterList, setRateMasterList] = useState(initialRateMasterDetails);

    useEffect(() => {
        if (rangeMasterList.length > 0) {
            setRateMasterList(rangeMasterList);
        } else {
            setRateMasterList(initialRateMasterDetails);
        }
    }, [rangeMasterList]);

    const updateRangeFeeMaster = (userType, rangeType, type, field, value) => {
        setRateMasterList((prevDetails) => {
            return prevDetails.map(detail => {
                if (detail.UserType === userType && detail.Type === rangeType && detail.WeekType === type) {
                    const updatedDetail = {
                        ...detail,
                        [field]: value,
                    };

                    const greenFee = parseFloat(updatedDetail.GreenFee) || 0;
                    const bucket = parseFloat(updatedDetail.Bucket) || 0;
                    const club = parseFloat(updatedDetail.Club) || 0;

                    const rate = greenFee + bucket + club;
                    const tax = rate * 0.18;
                    const total = rate + tax;

                    updatedDetail.Tax = Math.round(tax);
                    updatedDetail.Total = Math.round(total);

                    return updatedDetail;
                }
                return detail;
            });
        });
    };

    const handleSave = async () => {
        const btn = $('#btnSave');
        helper.StartProcessing(btn);

        try {
            await postRangeFeeMaster(rateMasterList);
           if (rateMasterList[0].ID) {
                swal.fire({
                    toast: true,
                    icon: 'success',
                    titleText: 'Master updated successfully!',
                    position: 'bottom-end',
                    showConfirmButton: false,
                    timer: 3500,
                    onOpen: () => swal.hideLoading()
                });
            } else {
                swal.fire({
                    icon: 'success',
                    titleText: 'Master added successfully!',
                    showConfirmButton: false,
                    timer: 3500,
                    onOpen: () => swal.hideLoading()
                });
            }
            fetchRangeFeeMasterByCalenderID(calenderID);
            helper.StopProcessing(btn);
        } catch (err) {
            helper.StopProcessing(btn);
            swal.fire({
                icon: 'error',
                titleText: 'Error!',
                text: err.message,
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-brand',
            });
            return;
        }
    };

    return (
        <div className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor padding-b0" id="kt_content" style={{ paddingTop: '0px' }}>
            <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid margin-t20">
                <div className="kt-portlet kt-portlet--mobile">
                    <div className="kt-portlet__body kt-portlet__body--fit padding-t20 padding-b0">
                        <div id="ControlHolder" className="kt-form kt-form--label-right padding-10 border-bottom-light" role="form">
                            <div className="row">
                                <div className="col-sm-3"></div>
                                <div className="form-group col-sm-2">
                                    <div className="ddlCoursePnl">
                                        <Select
                                            value={calenderID && { label: allMaster.find(c => c.ID === calenderID).Name, value: calenderID }}
                                            onChange={(event) => setCalenderID(event.value)}
                                            name="ddlMaster"
                                            placeholder="Select Calendar Master"
                                            id="ddlMaster"
                                            className="ddMaster"
                                            options={allMaster.map(c => ({
                                                label: c.Name,
                                                value: c.ID
                                            }))}
                                        />
                                    </div>
                                </div> 
                            </div>
                        </div>
                        <div>
                            {calenderID != null && (
                                <div id="accordionExample4">
                                    <div className="card-body">
                                        <div className="kt-widget4">
                                            <div className="kt-widget4__item padding-tb5">
                                                <table id="tblRangeFee" className="table table-bordered" style={{ width: '100%', backgroundColor: 'none' }}>
                                                    <thead>
                                                        <tr>
                                                            <th style={{ width: '5%' }}>No</th>
                                                            <th style={{ width: '15%' }}>Particular</th>
                                                            <th style={{ width: '10%' }}>Type</th>
                                                            <th style={{ width: '10%' }}>Days</th>
                                                            <th style={{ width: '10%' }}>Range Fee</th>
                                                            <th style={{ width: '10%' }}>Bucket</th>
                                                            <th style={{ width: '10%' }}>Club</th>
                                                            <th style={{ width: '10%' }}>Tax</th>
                                                            <th style={{ width: '10%' }}>Total</th>
                                                            <th style={{ width: '15%' }}>Remarks</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {rateMasterList.length > 0 && rateMasterList.map((detail, index) => (
                                                            <tr key={index}>
                                                                <td>{index + 1}</td>
                                                                <td>{detail.UserType}</td>
                                                                <td>{detail.Type}</td>
                                                                <td>{detail.WeekType}</td>
                                                                <td>
                                                                    <input
                                                                        type="number"
                                                                        className="form-control input-sm"
                                                                        value={detail.GreenFee || 0}
                                                                        onChange={(e) => updateRangeFeeMaster(detail.UserType, detail.Type, detail.WeekType, 'GreenFee', e.target.value)}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="number"
                                                                        className="form-control input-sm"
                                                                        value={detail.Bucket || 0}
                                                                        onChange={(e) => updateRangeFeeMaster(detail.UserType, detail.Type, detail.WeekType, 'Bucket', e.target.value)}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="number"
                                                                        className="form-control input-sm"
                                                                        value={detail.Club || 0}
                                                                        onChange={(e) => updateRangeFeeMaster(detail.UserType, detail.Type, detail.WeekType, 'Club', e.target.value)}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="number"
                                                                        className="form-control input-sm"
                                                                        value={Math.round(detail.Tax) || 0}
                                                                        disabled
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="number"
                                                                        className="form-control input-sm"
                                                                        value={Math.round(detail.Total) || 0}
                                                                        disabled
                                                                    />
                                                                </td>
                                                                 <td>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control input-sm"
                                                                        style={{ width: '100%', height: '40px' }}
                                                                        value={detail.Remark || ''}
                                                                        onChange={(e) => updateRangeFeeMaster(detail.UserType, detail.Type, detail.WeekType, 'Remark', e.target.value)}
                                                                    />
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="kt-portlet__foot text-center">
                        <button id="btnSave" onClick={handleSave} className="btn btn-primary btn-md">
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RangeFeeMaster;
